import { createApiSlice } from "@common";
import { CRUD_DECISION_AUTHORITY } from "@routes";

const apiConfig = [
  {
    name: "addDecisionAuthority",
    method: "post",
    url: CRUD_DECISION_AUTHORITY,
    stateKey: "message",
  },
  {
    name: "getDecisionAuthority",
    method: "get",
    url: CRUD_DECISION_AUTHORITY,
    stateKey: "data",
  },
  {
    name: "updateDecisionAuthority",
    method: "put",
    url: CRUD_DECISION_AUTHORITY,
    stateKey: "message",
  },
  {
    name: "deleteDecisionAuthority",
    method: "delete",
    url: CRUD_DECISION_AUTHORITY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice("decisionAuthority", apiConfig, customReducers);
const decisionAuthoritySlice = slice;

export default decisionAuthoritySlice.reducer;

export const {
  addDecisionAuthority,
  getDecisionAuthority,
  updateDecisionAuthority,
  deleteDecisionAuthority,
} = thunks;

export const { rowSelect } = actions;
